<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        {{
        $t("packing_type_crud.packing_types")
        }}
      </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">
            {{
            $t("packing_type_crud.new")
            }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <div class="container">
                <div class="row">
                  <div class="col">
                    <v-text-field
                      v-model="editedItem.description"
                      :label="this.$t('packing_type_crud.description')"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      v-model="editedItem.spacing_sides"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.spacing_sides')"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.spacing_between"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.spacing_between')"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.spacing_ends"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.spacing_ends')"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.pallet_height"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.pallet_height')"
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.pallet_width"
                      type="number"
                      step="100"
                      min="0"
                      :label="this.$t('packing_type_crud.pallet_width')"
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.default_truck_spacing"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.default_truck_spacing')"
                    ></v-text-field>
                  </div>
                  <div class="col">
                    <v-text-field
                      v-model="editedItem.truck_width"
                      type="number"
                      step="100"
                      min="0"
                      :label="this.$t('packing_type_crud.truck_width')"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.truck_length"
                      type="number"
                      step="100"
                      min="0"
                      :label="this.$t('packing_type_crud.truck_length')"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.truck_height"
                      type="number"
                      step="100"
                      min="0"
                      :label="this.$t('packing_type_crud.truck_height')"
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.max_weight"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.max_weight')"
                    ></v-text-field>

                    <v-text-field
                      v-model="editedItem.max_height"
                      type="number"
                      step="10"
                      min="0"
                      :label="this.$t('packing_type_crud.max_height')"
                    ></v-text-field>

                    <v-switch
                      v-model="editedItem.allow_different_orders"
                      :label="
                        this.$t('packing_type_crud.allow_different_orders')
                      "
                    ></v-switch>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              v-if="editedIndex === -1"
              @click="save"
            >{{ $t("packing_type_crud.okay") }}</v-btn>
            <v-btn
              color="blue darken-1"
              flat
              v-if="editedIndex !== -1"
              @click="edit"
            >{{ $t("packing_type_crud.edit") }}</v-btn>
            <v-btn color="blue darken-1" flat @click="close">
              {{
              $t("packing_type_crud.cancel")
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
        </div>
        <div class="rTableRow" v-for="(packingType, i ) in packingTypes" :key="i">
          <div class="rTableCell">
            <input type="radio" :checked="packingType.selected" @change="checked(packingType)" />
          </div>
          <div class="rTableCell">{{ packingType.description }}</div>
          <div class="rTableCell number-cell">{{ packingType.pallet_height }}</div>
          <div class="rTableCell number-cell">{{ packingType.max_weight }}</div>
          <div class="rTableCell number-cell">{{ packingType.max_height }}</div>
          <div class="rTableCell number-cell">{{ packingType.pallet_width }}</div>
          <div class="rTableCell number-cell">{{ packingType.spacing_between }}</div>
          <div class="rTableCell number-cell">{{ packingType.spacing_ends }}</div>
          <div class="rTableCell number-cell">{{ packingType.spacing_sides }}</div>
          <div class="rTableCell number-cell">{{ packingType.truck_height }}</div>
          <div class="rTableCell number-cell">{{ packingType.truck_length }}</div>
          <div class="rTableCell number-cell">{{ packingType.truck_width }}</div>
          <div class="rTableCell">{{ allowDifferentOrders(packingType.allow_different_orders) }}</div>
          <div class="rTableCell number-cell">{{ packingType.default_truck_spacing }}</div>
          <div class="rTableCell">
            <v-icon small class="mr-2" @click="editItem(packingType)">edit</v-icon>
            <v-icon small @click="deleteItem(packingType)">delete</v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PackingType from "@/models/PackingType.js";
import User from "@/models/User.js";
export default {
  data() {
    return {
      packingTypes: [],
      company: null,
      dialog: false,
      loading: false,
      headers: [
        {
          text: this.$t("packing_type_crud.default"),
          value: "-1",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.description"),
          value: "description",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.pallet_height"),
          value: "pallet_height",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.max_weight"),
          value: "max_weight",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.max_height"),
          value: "max_height",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.pallet_width"),
          value: "pallet_width",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.spacing_between"),
          value: "spacing_between",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.spacing_ends"),
          value: "spacing_ends",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.spacing_sides"),
          value: "spacing_sides",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.truck_height"),
          value: "truck_height",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.truck_length"),
          value: "truck_length",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.truck_width"),
          value: "truck_width",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.allow_different_orders"),
          value: "allow_different_orders",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.default_truck_spacing"),
          value: "allow_different_orders",
          width: "50px",
          sortable: false,
        },
        {
          text: this.$t("packing_type_crud.actions"),
          value: "actions",
          width: "50px",
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 20,
      },
      editedIndex: -1,
      editedItem: {
        description: "",
        pallet_height: 0,
        max_weight: 0,
        max_height: 0,
        pallet_width: 0,
        spacing_between: 0,
        spacing_ends: 0,
        spacing_sides: 0,
        truck_height: 0,
        truck_length: 0,
        truck_width: 0,
        default_truck_spacing: 50,
      },
      defaultItem: {
        pallet_height: 0,
        max_weight: 0,
        max_height: 0,
        pallet_width: 0,
        spacing_between: 0,
        spacing_ends: 0,
        spacing_sides: 0,
        truck_height: 0,
        truck_length: 0,
        truck_width: 0,
        default_truck_spacing: 50,
      },
      packingTypeObj: new PackingType(this.$session.get("jwt")),
      user: new User(this.$session.get("user")),
      onKeyUp: (e) => {
        if (e.key === "Enter") {
          if (this.editedIndex === -1) {
            this.save();
          } else {
            this.edit();
          }
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("packing_type_crud.new_packing_type")
        : this.$t("packing_type_crud.edit_packing_type");
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },

  async mounted() {
    const user = await User.loadMe();
    this.user = new User(user);
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      this.packingTypes = await PackingType.loadPackingTypes();
      this.packingTypes.forEach((packingType) => {
        packingType["selected"] =
          packingType.id == this.user.company.pref_packing_type;
      });
      this.loading = false;
    },

    allowDifferentOrders(allow) {
      if (allow) {
        return this.$t("packing_type_crud.yes");
      }
      return this.$t("packing_type_crud.no");
    },

    async checked(packingType) {
      await this.user.company.save({
        pref_packing_type: packingType.id,
      });
      this.user.company.pref_packing_type = packingType.id;
      this.initialize();
    },

    editItem(packingType) {
      this.editedIndex = this.packingTypes.indexOf(packingType);
      this.editedItem = new PackingType(packingType);
      this.dialog = true;
    },

    deleteItem(packingType) {
      confirm(this.$t("packing_type_crud.delete_confirm")) &&
        packingType.delete();
      this.initialize();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      await PackingType.create(this.editedItem);
      this.initialize();
      this.close();
    },

    async edit() {
      await this.editedItem.save();
      this.initialize();
      this.close();
    },
  },
};
</script>

<style>
</style>
